module.exports = __webpack_public_path__ + "img/patients10.66c09940.jpg";